<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html,
body {
  background: #eeefef;
}
</style>



// WEBPACK FOOTER //
// src/App.vue